var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewCampaigns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 113,
    viewBox: "0 0 128 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 56.65C8 71.5021 13.9 85.746 24.402 96.248C34.9041 106.75 49.1479 112.65 64 112.65C78.8521 112.65 93.0959 106.75 103.598 96.248C114.1 85.746 120 71.5021 120 56.65C120 41.7979 114.1 27.5541 103.598 17.052C93.0959 6.55001 78.8521 0.650024 64 0.650024C49.1479 0.650024 34.9041 6.55001 24.402 17.052C13.9 27.5541 8 41.7979 8 56.65Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.082 74.5H10.9199C14.6573 85.6177 21.7912 95.2813 31.315 102.127C40.8388 108.973 52.2719 112.656 64.0009 112.656C75.73 112.656 87.163 108.973 96.6868 102.127C106.211 95.2813 113.345 85.6177 117.082 74.5Z",
    fill: "#D9CC85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7188 93.9586L65.2808 95.7772",
    stroke: "#0D0D0D",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3319 85.8148L73.1973 86.001",
    stroke: "#0D0D0D",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2378 91.804L47.457 89.2168",
    stroke: "#0D0D0D",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1992 88.2592L27.2902 85.119",
    stroke: "#0D0D0D",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1309 98.7565L89.2319 99.2563",
    stroke: "#0D0D0D",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7129 107.126L56.0667 104.291",
    stroke: "#0D0D0D",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.207 101.474L77.0854 100.219",
    stroke: "#0D0D0D",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5449 98.9328L38.8973 96.0978",
    stroke: "#0D0D0D",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M123.5 74.4762H127",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1 74.4762H4.5",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M120.701 74.5043H7.30078",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8197 42.6444C76.8197 42.6444 74.6693 52.2652 79.3999 57.3934C81.9997 60.2116 86.6155 60.3208 88.4481 55.2472C93.6519 53.8276 93.9977 48.0358 90.6797 46.115C86.9711 43.9674 82.9153 47.8874 76.8197 42.6444Z",
    fill: "white",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M107.323 48.6504C107.323 48.6504 109.806 56.1768 106.426 60.6554C104.568 63.1152 100.886 63.5688 99.0172 59.6544C94.7402 58.9306 94.0052 54.3246 96.5084 52.5256C99.3056 50.5124 102.862 53.3278 107.323 48.6504Z",
    fill: "white",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0399 60.4538C59.8716 59.5893 60.0126 58.6931 60.4382 57.922C60.8638 57.151 61.5469 56.554 62.3681 56.2356C65.0757 55.0778 69.4129 56.4442 71.2175 55.6756C73.0221 54.907 66.8831 64.3738 60.0399 60.4538Z",
    fill: "white",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7833 68.4268C57.598 67.5658 57.1159 66.7973 56.4213 66.2558C55.7268 65.7143 54.8639 65.4341 53.9837 65.4644C51.0437 65.4644 47.5885 68.4268 45.6257 68.4268C43.6629 68.4268 53.0345 74.7226 57.7833 68.4268Z",
    fill: "white",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9859 75.4716C54.1059 65.7444 62.1195 64.8792 60.0965 60.4916",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6228 67.94C23.777 68.6009 24.3065 69.1458 25.0947 69.4546C25.8829 69.7635 26.8652 69.8111 27.8256 69.5869C28.7859 69.3627 29.6457 68.8852 30.2156 68.2593C30.7856 67.6334 31.0192 66.9104 30.8649 66.2495C30.7106 65.5885 30.1811 65.0436 29.3929 64.7348C28.6048 64.4259 27.6224 64.3783 26.6621 64.6025C25.7017 64.8267 24.842 65.3042 24.272 65.9301C23.702 66.556 23.4685 67.279 23.6228 67.94Z",
    fill: "white",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8652 66.2512C31.9916 68.4448 32.452 70.9198 32.1896 73.3716C32.1896 73.3716 30.9184 77.5016 32.0272 80.156",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3906 84.8223C59.9308 80.1477 56.1872 77.9553 59.9868 75.4717C64.7244 77.1811 60.2332 82.2561 65.7268 83.1885",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6875 66.1785V78.4061",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6864 78.406C87.8614 80.1476 91.2886 87.086 87.5898 88.7884",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3982 82.0601C89.7286 82.8663 88.9012 83.5271 87.9668 84.0019C87.0325 84.4767 86.0109 84.7554 84.9648 84.8209",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6875 78.406C101.512 80.1476 98.9281 85.5796 102.627 87.2862",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8234 82.8455C99.0342 83.8203 98.6035 85.0366 98.6035 86.2909C98.6035 87.5451 99.0342 88.7614 99.8234 89.7363",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6875 78.406C94.6875 78.406 93.1769 81.906 94.4887 84.6178C95.8005 87.3296 94.6875 91.8362 94.6875 91.8362",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0249 86.498C94.1782 87.8292 92.9565 88.8799 91.5137 89.5178",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M103.808 54.9533C98.3131 58.7725 94.6871 66.1785 94.6871 66.1785C94.6871 66.1785 92.3757 54.2337 82.0059 50.4523",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4941 13.005V10.499",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8589 17.4094L31.0879 15.6384",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4552 28.0438H25.9492",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8589 38.6782L31.0879 40.4506",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9648 17.4094L56.7358 15.6384",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3691 28.0438H61.8751",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9648 38.6782L56.7358 40.4506",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4941 43.0826V45.5886",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7969 28.0438C31.7969 29.5799 32.0994 31.1009 32.6873 32.5201C33.2751 33.9392 34.1367 35.2287 35.2228 36.3148C36.309 37.401 37.5985 38.2626 39.0176 38.8504C40.4368 39.4383 41.9578 39.7408 43.4939 39.7408C45.0299 39.7408 46.551 39.4383 47.9701 38.8504C49.3893 38.2626 50.6787 37.401 51.7649 36.3148C52.8511 35.2287 53.7127 33.9392 54.3005 32.5201C54.8883 31.1009 55.1909 29.5799 55.1909 28.0438C55.1909 26.5077 54.8883 24.9867 54.3005 23.5676C53.7127 22.1484 52.8511 20.8589 51.7649 19.7728C50.6787 18.6866 49.3893 17.825 47.9701 17.2372C46.551 16.6494 45.0299 16.3468 43.4939 16.3468C41.9578 16.3468 40.4368 16.6494 39.0176 17.2372C37.5985 17.825 36.309 18.6866 35.2228 19.7728C34.1367 20.8589 33.2751 22.1484 32.6873 23.5676C32.0994 24.9867 31.7969 26.5077 31.7969 28.0438Z",
    fill: "#FFE137",
    stroke: "#0D0D0D",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewCampaigns);
export default __webpack_public_path__ + "static/media/view-campaigns.384552cd9d56087c00ae7055a6dbc0a9.svg";
export { ForwardRef as ReactComponent };